export const FORM_DATE_FORMAT = "DD.MM.YYYY";
export const FHIR_DATE_FORMAT = "YYYY-MM-DD";

// TODO: LOINC, SNOMED SCT systems

export const FHIR_EXT_ENTRY_CROSS_REF =
  "http://fhir.ch/ig/ch-vacd/StructureDefinition/ch-vacd-ext-cross-reference";
export const FHIR_EXT_ENTRY_CROSS_REF_STU5 =
  "http://fhir.ch/ig/ch-core/StructureDefinition/ch-core-ext-entry-resource-cross-references";
export const FHIR_EXT_AUTHOR_ROLE =
  "http://fhir.ch/ig/ch-epr-fhir/StructureDefinition/ch-ext-author-authorrole";
export const FHIR_EXT_CONFIDENTIALITY =
  "http://fhir.ch/ig/ch-core/StructureDefinition/ch-ext-epr-confidentialitycode";
export const FHIR_EXT_MERGING_CONFLICT =
  "http://fhir.ch/ig/ch-vacd/StructureDefinition/ch-vacd-ext-merging-conflict-entry-reference";

export const FHIR_EXT_ORIGINAL_COMPOSITION_UUID =
  "https://fhir.bint.ch/ig/epr/StructureDefinition/original-composition-uuid";
export const FHIR_EXT_REPLACED_BY = "https://fhir.bint.ch/ig/epr/StructureDefinition/replaced-by";

export const ORIGINAL_PROVIDER_ROLE_SYSTEM = "urn:oid:2.16.756.5.30.1.127.3.10.6";
